import Settings from './Settings.vue'
import List from './List.vue'
import New from './New.vue'
import Edit from './Edit.vue'
import Delete from './Delete.vue'
import { Route } from 'vue-router'

export const All = [Settings, List, New, Edit, Delete]

export default {
  Settings,
  List,
  New,
  Edit,
  Delete
}

export const RouteConfig = [
  {
    path: 'projects',
    component: Settings,
    name: 'settings-projects',
    children: [
      {
        path: 'list',
        component: List,
        name: 'settings-projects-list',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':projectId/edit/',
        component: Edit,
        name: 'settings-projects-edit',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            projectId: route?.params?.projectId
          }
        }
      },
      {
        path: 'new',
        component: New,
        name: 'settings-projects-new',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':projectId/delete',
        component: Delete,
        name: 'settings-projects-delete',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            projectId: route?.params?.projectId
          }
        }
      },
      {
        path: '',
        component: Settings,
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      }
    ]
  }
]
